import { useCallback } from 'react';

import { getAtlasURL } from '../../common/utils/atlas-url/index.ts';
import { useTenantDataController } from '../tenant-data/index.tsx';

export const useAtlasURL = (siteId: string): {
    atlasURL: (path: string) => string;
} => {
	const { data: tenantData } = useTenantDataController(siteId);

	const atlasURL = useCallback(
		(path: string): string => getAtlasURL(siteId, path, tenantData?.orgId),
		[siteId, tenantData?.orgId],
	);

	return {
		atlasURL,
	};
};

/**
 * @deprecated Use getAtlassianStudioNLCreateUrl instead
 */
export const useCreateAgentAtlasURL = (siteId: string): string => {
	const { atlasURL } = useAtlasURL(siteId);
	return atlasURL('/chat/agents/new');
};
